import axios from 'axios'
export default {
  CLEAR_PROFILE({ commit }) {
    commit('CLEAR_PROFILE')
  },
  GET_PROFILE({ commit }) {
    axios({
      method: 'GET',
      url: '/api/user/getName'
    })
      .then(response => {
        commit('GET_PROFILE_SUCCESS', response.data)
      })
      .catch(error => {
        commit('GET_PROFILE_ERROR', error.response.data.message)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/profile/actions.js